/* unplugin-vue-components disabled */import { render } from "./BroadNetProtocol.vue?vue&type=template&id=a0b7a76a"
import script from "./BroadNetProtocol.vue?vue&type=script&lang=js"
export * from "./BroadNetProtocol.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__